import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
    Modal,
    Input,
    Row,
    Typography,
    Col,
    Card,
    Table,
    Spin,
    Select,
    Button,
    Form,
    Divider
} from "antd";
import { ExclamationOutlined } from '@ant-design/icons';

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import DownloadTableButtons from "../../../components/DownloadTableButtons";

import { rightAction } from "../../../redux/actions";
import { apiConfig, labelConfig, staticConfig } from "../../configurations/configurations.config";
import CustomButton from "../../../components/custom/CustomButton";

const ViewHistory = (props) => {
    //DECLARED VARIABLES
    const { userData, rightBtn, rightAction } = props;
    const { session } = userData;
    const { Text } = Typography;
    const navigate = useNavigate();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
    const [offset, setOffset] = useState(0); // Offset for API
    const [tableCount, setTableCount] = useState("10");
    const [historyList, setHistoryList] = useState([]);
    const [originalList, setOriginalList] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0); // Total record count
    const [currentPage, setCurrentPage] = useState(1); // Current page number
    const limit = 14; // Page size (items per page)

    useEffect(() => {
        getHistoryListAction(0);
    }, []);

    const getHistoryListAction = (currentOffset = 0) => {

        const url = `${apiConfig.Jobs}/${state.id}/runhistory`;

        const params = {
            limit: limit,
            offset: currentOffset
        }

        let body = {
            session,
            params
        };
        setIsLoading(false);

        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
            } else {
                const objList = res.pageItems;
                let tempArray = [];

                objList?.forEach((element) => {
                    tempArray.push({
                        key: element?.version,
                        id: element?.version,
                        runStartTime: element?.jobRunStartTime ? element?.jobRunStartTime : "-",
                        version: element?.version ? element?.version : "-",
                        status: element?.status ? element?.status : "-",
                        runType: element?.triggerType ? element?.triggerType : "-",
                        errorLog: element.jobRunErrorLog ? element?.jobRunErrorLog : "-",
                    });
                });

                setHistoryList(tempArray);

                //keep the orginal data to use after gList is modified when change from autorise to disable
                setOriginalList(tempArray);

                // If we received fewer than 'limit' records, this is the last page.
                if (objList.length < limit) {
                    setTotalRecords(offset + objList.length);
                } else {
                    // Otherwise, we might not know the total.
                    // Here we set a dummy total that allows further paging.
                    // Alternatively, if your API returns a total count, use that.
                    setTotalRecords(offset + limit * 10);
                }

                //STOP LOAD
                setIsLoading(false);
            }
        });
    };

    //DECLARED METHODS

    // Handle page changes (Next/Previous)
    const handlePageChange = (page) => {
        const newOffset = (page - 1) * limit;
        setCurrentPage(page);
        setOffset(newOffset);
        getHistoryListAction(newOffset);
    };

    function handleSearchInTable(searchKey) {
        searchKey = searchKey.target.value;

        console.log(searchKey)

        if (!searchKey) {
            setHistoryList(originalList);
            return;
        }
        const filterBySearch = originalList.filter((item) => item?.version === parseInt(searchKey));
        setHistoryList(filterBySearch);
    }

    function selectTableCount(value) {
        setTableCount(value);
    }

    function handleErrorModal() {
        setIsErrorModalOpen(true)
    }

    const columns = [
        {
            title: labelConfig.version,
            dataIndex: "version",
        },
        {
            title: labelConfig.runStartTime,
            dataIndex: "runStartTime",
        },

        {
            title: labelConfig.status,
            dataIndex: "status",
        },

        {
            title: labelConfig.runType,
            dataIndex: "runType",
        },
        {
            title: labelConfig.errorLog,
            dataIndex: "errorLog",
            // render: (_, record) => console.log(record),
            render: (_, record) => record?.errorLog !== "-" &&
                <ErrorLogModal
                    userData={userData}
                    isErrorModalOpen={isErrorModalOpen}
                    setIsErrorModalOpen={setIsErrorModalOpen}
                    handleErrorModal={handleErrorModal}
                    errorData={record?.errorLog}
                />
        },
    ];

    return (
        <MainLayout
            isEnableRightSidebar={true}
        >
            <TopContent
                pageTitle={labelConfig.schedulerJobHistory}
                pageItems={staticConfig.schedulerJobHistoryBreadcrumbItems}
            />

            <Card
                title={`${labelConfig.schedulerJobHistory} List`}
                style={{
                    boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                }}
            >
                {/* RENDER TABLE LIST HERE*/}
                <Spin spinning={isLoading} size="large">
                    <Row style={{ marginBottom: 20 }}>
                        <div style={{ marginBottom: "auto" }}>
                            <Text style={{ marginRight: 8 }}>Show</Text>
                            <Select
                                defaultValue={tableCount}
                                options={[
                                    { value: "5", label: "5" },
                                    { value: "10", label: "10" },
                                    { value: "25", label: "25" },
                                    { value: "50", label: "50" },
                                ]}
                                onSelect={selectTableCount}
                            />
                            <Text style={{ marginLeft: 8 }}>Entries</Text>
                        </div>
                        <div style={{ margin: "0px 50px" }}>
                            <Input
                                onChange={handleSearchInTable}
                                placeholder="Filter by Version..."
                                style={{
                                    width: 400,
                                }}
                            />
                        </div>
                    </Row>
                    <Table
                        columns={columns}
                        dataSource={historyList}
                        bordered
                        pagination={{
                            position: "bottomCentre",
                            current: currentPage,
                            pageSize: limit,
                            total: totalRecords,
                            onChange: handlePageChange,
                            showSizeChanger: false,
                        }}
                    />
                </Spin>
            </Card>
        </MainLayout>
    );
};

export default ViewHistory

export const ErrorLogModal = (props) => {
    const { isErrorModalOpen, setIsErrorModalOpen, errorData, handleErrorModal } =
        props;

    const [useForm] = Form.useForm();

    const showModal = () => {
        setIsErrorModalOpen(true);
    };

    const handleCancel = () => {
        setIsErrorModalOpen(false);
    };


    return (
        <Row>
            <Button
                type="primary"
                shape="round"
                size="small"
                className="of-primaryBtnColor"
                onClick={handleErrorModal}
                icon={<ExclamationOutlined />}
                style={{ backgroundColor: "#15CCAE", color: "white", width: "10vh" }}
            >
                View
            </Button>

            <Modal
                title="Error Log"
                open={isErrorModalOpen}
                footer={null}
                onCancel={handleCancel}
                width={1000}
                styles={{ body: { overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' } }}
            >
                <Form
                    form={useForm}
                    layout="vertical"
                >

                    {errorData}

                    <Row>
                        <Divider />

                        <CustomButton
                            content="Cancel"
                            style={{
                                width: "10%",
                                marginLeft: "auto",
                                marginRight: "3%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            }}
                            backgroundColor="#fff"
                            colorText="black"
                            hoverBackground="#F5F5F5"
                            onClick={() => setIsErrorModalOpen(false)}
                        />
                    </Row>
                </Form>
            </Modal>
        </Row>
    );
};